import { ContentSwiper } from 'src/components/common/Swipers/ContentSwiper';
import styled from 'styled-components';

export const ThumbnailSwiper = styled(ContentSwiper)`
  .swiper-slide {
    width: 264px;
    margin-right: 20px;
  }
`;
